import React, { useEffect, useState } from 'react';
import {
  Nav,
  NavDropdown,
} from 'react-bootstrap';
import config from '../../config';
import { isMobile } from 'react-device-detect'


function DynamicMenu({ section }) {
  const [menu, setMenu] = useState({})
  const [titleMenu, setTitleMenu] = useState([])
  const user = sessionStorage.getItem('_id');
  const company = sessionStorage.getItem('company');

  useEffect(() => {
    console.log(user)
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'currentuser': user,
        'empresa': company,
      }
    }
    fetch(config.servBackEnd + '/modules/menu/' + section, datasend).then(response => response.json())
      .then(data => {
        setTitleMenu(Object.keys(data));
        setMenu(data);
      });
  }, [])

  const menuComponent = (title, key) => {
    if (Object.keys(menu).length !== 0) {
      const modulos = menu[title]
      return (
        <NavDropdown key={key} title={title} id="collasible-nav-dropdown" className="navbar-dropdown-menu">
          {modulos.map((element) => {
            if (element.URL === '/ventas/pedidos' && isMobile) element.URL += 'movil'
            return <NavDropdown.Item disabled={!(parseInt(element.ACTIVO, 10) === 1)} key={element.ID} href={element.URL} className="navbar-dropdown-item">{element.NOMBRE_MODULO}</NavDropdown.Item>
          }
          )}
        </NavDropdown>
      )
    }
  }

  return (
    <Nav>
      {
        titleMenu.map((title, key) => menuComponent(title, key))
      }
    </Nav>
  );
}

export default DynamicMenu;


// WEBPACK FOOTER //
// ./src/components/menu/dynamic_menu.jsx